<template>
  <div id="Pay" class="main-wrapper slideUp">
    <div class="back-button" @click="end()">
      <i class="anyteachicon anyteach-caret-square-left" />返回
    </div>
    <div v-if="coupons && user">
      <div class="section-header">
        <i class="anyteachicon anyteach-dollar-sign" />拼课支付
      </div>
      <div class="select-wrapper">
        <h2 class="title">课程单价</h2>
        <h3 v-if="data.user_type == 1">¥{{ data.o_price }}</h3>
        <h3 v-else>¥{{ data.price }}</h3>
      </div>
      <div class="select-wrapper">
        <h2 class="title">实际支付</h2>
        <h3>¥{{ payables.payable }}</h3>
      </div>
      <div class="section-header-small">优惠</div>
      <div v-if="reward[0]" class="select-wrapper">
        <h2>首单用户奖励</h2>
        <h3>¥{{ reward.reduce((total, item) => total + parseInt(item.r_content), 0) }}</h3>
      </div>
      <div v-if="payables.creditPayable" class="select-wrapper">
        <h2 class="title">学分抵扣</h2>
        <h3>{{ payables.creditPayable }} 学分抵扣 ¥{{ payables.creditPayable * 10 }}</h3>
      </div>
      <div v-if="!coupons[0]" class="select-wrapper">
        <h2 class="title">学习券</h2>
        <h3>无可用学习券</h3>
      </div>
      <div v-else class="select-wrapper">
        <i class="anyteachicon anyteach-caret-right" />
        <h2 class="title">学习券</h2>
        <h3 v-if="!coupon" @click="isShowCoupon = true">
          <span>{{ coupons.length }} 张学习券可用</span>
        </h3>
        <h3 v-else class @click="isShowCoupon = true">已抵用 ¥{{ coupon.amount }}</h3>
      </div>
      <div v-if="isShowCoupon" id="coupon-selector" class="animated">
        <div class="back-button" @click="isShowCoupon = false">
          <i class="anyteachicon anyteach-caret-square-left" />返回
        </div>
        <br />
        <br />
        <div class="coupon-selector-null coupon" @click="clearCoupon()">
          <i
            :class="{ selected: coupon == '' }"
            class="couponSelectedIcon anyteachicon anyteach-check-circle"
          />
          <h2>不使用学习券</h2>
        </div>
        <div class="coupon-selector-coupons">
          <Coupon
            v-for="(value, key) in coupons"
            :key="key"
            :coupon-selected="coupon.id"
            :coupon="value"
            @click="select()"
            @selectCoupon="selectCoupon($event)"
          />
        </div>
      </div>
      <div class="large-action-button" @click="pay()">
        <span v-if="payables.payable">
          <i class="anyteachicon anyteach-weixinzhifu" />
          微信支付 ¥{{ payables.payable }}
        </span>
        <span v-else>支付 {{ payables.creditPayable }} 学分</span>
      </div>
    </div>
    <div v-else class="empty">
      <InlineLoading />
    </div>
    <Agreement v-if="isShowAgreement" @state="onAgreement($event)" />
  </div>
</template>
<script>
import Coupon from "@/components/public/Coupon"
import InlineLoading from "vux/src/components/inline-loading"
import Agreement from "../post/Agreement"
export default {
  name: "Pay",
  components: {
    Coupon,
    InlineLoading,
    Agreement,
  },
  props: ["data"],
  data() {
    return {
      coupons: false,
      coupon: "",
      user: "",
      isShowCoupon: false,
      isShowAgreement: false,
      payables: "",
      reward: [],
      r_u_id: "",
    }
  },
  watch: {
    coupon: function (newVal) {
      this.isShowCoupon = false
      this.getPayables()
    },
  },
  created() {
    if (this.$route.params.r_u_id) {
      this.r_u_id = this.data.user_type == 3 ? this.$route.params.r_u_id : ""
    }
    this.isShowAgreement = this.data.user_type == 3 ? true : false
    this.getCoupons()
    this.getUser()
  },
  methods: {
    onAgreement(state) {
      if (state == 1) {
        this.isShowAgreement = false
      } else {
        this.end()
      }
    },
    end() {
      document.getElementById("Pay").classList.remove("slideUp")
      document.getElementById("Pay").classList.add("slideDown")
      setTimeout(() => {
        document.getElementById("Pay").classList.add("slideUp")
        document.getElementById("Pay").classList.remove("slideDown")
        this.$emit("close")
      }, 300)
    },
    clearCoupon() {
      this.coupon = ""
      this.isShowCoupon = false
    },
    selectCoupon(id) {
      this.isShowCoupon = false
      this.coupon = id
    },
    getCoupons() {
      this.$axios({
        url: window.PHP_ROOT + "/index/User/redpackage",
        data: {
          m_id: this.data.id,
        },
        method: "POST",
      }).then(({ data }) => {
        this.coupons = data[0] ? data : true
      }).catch(error => { throw new Error(error) })
    },
    pay() {
      if (!this.$store.state.isWechat) {
        return this.$toastError("请在微信内打开")
      }
      this.$axios({
        url: window.PHP_ROOT + "/index/collage/join/",
        method: "POST",
        data: {
          id: this.data.id,
          coupon: this.coupon.id || "",
          r_u_id: this.r_u_id,
          payable: this.payables.payable,
          credit: this.payables.creditPayable,
        },
      }).then(({ data }) => {
        const { code, msg } = data
        if (code == 1000) {
          this.$emit("success")
        } else if (code == 2000) {
          let options = msg
          options.success = () => {
            this.$emit("success")
          }
          options.cancel = () => { }
          options.fail = err => {
            this.$toastError("支付失败：", err)
          }
          wx.chooseWXPay(options)
        } else {
          this.$toastError(`支付失败：${code}`)
        }
      }).catch(error => { throw new Error(error) })
    },
    getUser() {
      this.$axios(window.PHP_ROOT + "/index/User/profile/")
        .then(({ data }) => {
          const { code, msg } = data
          if (code === "1000") {
            this.user = msg
            this.getPayables()
          }
        }).catch(error => { throw new Error(error) })
    },
    getPayables() {
      this.reward =
        this.data.user_type == 1
          ? this.data.sub_user.filter(item => item.isFirstTime && item.r_u_id == this.user.user_id)
          : []
      const price = this.data.user_type == 1 ? this.data.o_price : this.data.price
      const userCredit = this.user.credit
      const coupon = this.coupon
      const priceDeducted = coupon ? price - coupon.amount : price
      const priceAsCredit = Math.floor(priceDeducted / 10)

      let payable = 0,
        creditPayable = 0
      if (userCredit) {
        if (priceAsCredit > userCredit) {
          payable = priceDeducted - userCredit * 10
          creditPayable = userCredit
        } else {
          creditPayable = priceAsCredit
          payable = priceDeducted - priceAsCredit * 10
        }
      } else {
        payable = priceDeducted
      }
      this.payables = {
        price: price,
        priceDeducted: priceDeducted,
        priceAsCredit: priceAsCredit,
        userCredit: userCredit,
        payable: payable,
        creditPayable: creditPayable,
        coupon: coupon,
      }
      this.$forceUpdate()
    },
  },
}
</script>

<style scoped lang="scss">
// @import "../../../../static/css/public.scss";

@import "../../../../static/css/prog-form.scss";

#Pay {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  overflow: scroll;
  width: 100%;
  z-index: 1;
  background-color: white;
  animation-duration: 0.3s !important;
  animation-timing-function: ease-in-out !important;
  padding: 5% 5% 30px 5%;
  @include avenir();
  .empty {
    height: 90vh;
  }
}

.large-action-button {
  font-size: 15px;
  font-weight: 400;
  @include avenir-demi();
  border-radius: 5px;
  background: $blue;
  padding: 13px;
  i {
    margin: 0 3px 0 0;
  }
}

#coupon-selector {
  position: fixed;
  top: 0;
  height: 100vh;
  overflow: scroll;
  width: 100%;
  left: 0;
  padding: 5%;
  background-color: white;
  animation-duration: 0.3s !important;
  animation-timing-function: ease-in-out !important;
  .coupon-selector-null {
    h2 {
      border: none;
      padding: 0;
      margin: 0;
    }
  }
  .coupon-selector-coupons {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid $lightGrey;
  }
}

.select-wrapper {
  position: relative;
  i {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    color: $grey;
  }
}
</style>
